import { Locale } from '@/constants/locale';
import useLocale from '@/hooks/useLocale';
import { Image } from '@/components/Image';

const LANGUAGES = [
  { locale: Locale.EN, text: 'English' },
  { locale: Locale.ZH, text: '简体' },
  { locale: Locale.JA, text: '日本語' },
  { locale: Locale.ES, text: 'Español' }
] as const;

interface LanguageItemProps {
  text: string;
  selected: boolean;
  onClick?: () => void;
}

const LanguageItem = ({ selected, onClick, text }: LanguageItemProps) => (
  <button
    className="flex justify-between h-[56px] p-4 rounded-[10px] items-center  cursor-pointer"
    onClick={() => {
      onClick?.();
    }}
  >
    <span className={`${selected ? 'text-[#262626]' : 'text-[#999999]'}`}>{text}</span>
    {selected && <Image alt={'check-line-svg'} width={20} height={20} src={'/icons/check-line.svg'} />}
  </button>
);

interface IProps {
  onCountryClick: () => void;
}

const CountryModal = ({ onCountryClick }: IProps) => {
  const { locale, changeLocale } = useLocale();

  return (
    <div
      className="bg-white text-[16px] font-medium w-[180px] rounded-[10px] border shadow-[4px_4px_16px_0_rgba(0,0,0,0.10)] border-[#f5f5f5] flex flex-col justify-between absolute top-[67px] right-[82px] z-50"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {LANGUAGES.map((language, idx) => (
        <LanguageItem
          key={idx}
          text={language.text}
          selected={language.locale === locale}
          onClick={() => {
            onCountryClick();
            changeLocale(language.locale);
          }}
        />
      ))}
    </div>
  );
};

export default CountryModal;
